<template>
  <div class="segment-input-group">
    <label class="input-label">{{dynamicInputs.view.name}}<span class="field-info" v-if="dynamicInputs.view.description" v-tooltip="dynamicInputs.view.description"></span></label>
    <div class="dynamic-input-wrapper" v-for="(input,i) in nonZeroInputs" :key="i">
      <input-container class="input-box" v-model="nonZeroInputs[i]" :style="{marginBottom: 0}" :key="i"/>
      <div class="delete-button" :class="{disabled: !canRemoveInputs}" @click="onRemoveInput(input)"></div> 
    </div>
    <div class="add-button" v-if="canAddMoreInputs()" @click="onAddInput">+ Add dose</div>
    <div class="no-more-add" v-else>Max {{max}} doses</div>
  </div>
</template>

<script>
import InputContainer from '@/components/inputs/InputContainer'

export default {
  name: 'DynamicInputGroup',
  components: {InputContainer},
  props: {
    values: Array,
    min: {
      type: Number,
      default: 2
    },
    max: {
      type: Number,
      default: 10
    },
  },
  model:{
    prop: 'values',
    event: 'change'
  },
  computed:{
    nonZeroInputs() {
      let nonZeroInputs = this.values[0].value.filter(input => input.value[0] != 0)
      return nonZeroInputs
    },
    dynamicInputs: {
      get () {
        return this.values[0]
      }
    },
    canRemoveInputs() {
      return this.nonZeroInputs.length > this.min
    },
  },
  methods:{
    onValuesChange (){
      this.$emit('change',JSON.parse(JSON.stringify(this.dynamicInputs)))
    },
    onAddInput(){
      // TODO: add new template input type to allow dynamic inputs (for now it receives 10 value slots with 0s and fills them)
      let newInput = this.dynamicInputs.value.find(input => input.value[0] == 0)
      newInput.value = [1]
      let newInputIndex = this.dynamicInputs.value.findIndex(input => input == newInput)
      this.dynamicInputs.value.splice(newInputIndex, 1)
      this.dynamicInputs.value.push(newInput)
    },
    onRemoveInput(removeThis){
      let inputToRemove = this.dynamicInputs.value.find(input => input == removeThis)
      inputToRemove.value = [0]
    },
    canAddMoreInputs(){
      return this.nonZeroInputs.length < (this.max || Infinity)
    }    
  }
}
</script>

<style lang="stylus" scoped>
.segment-input-group
  margin-left: 10px

  .input-label
      color: $shuttle-gray
      display: block
      m-font-size(12, 14)
      margin-bottom: 5px
      .field-info
        display: inline-block
        m-icon('info', 14)
        margin-left 5px

  .dynamic-input-wrapper
    margin-bottom 10px
    border 2px solid  #f0f0f6
    border-radius 3px
    padding 2px
    background  #f0f0f6
    box-shadow 0 0 10px rgba($lynch, 0.25)
    display: flex
    direction: column

    .delete-button
        align-self: center
        justify-content: left
        m-icon("cross", 20)
        flex: 0 0 20px; 
        cursor: pointer
        margin-right: 10px
        &.disabled
          opacity: 0.4
          pointer-events: none

  .add-button
    margin: 10px 10px
    background: rgba(255, 255, 255, 0.5)
    border: 1px solid $cloud-burst
    border-radius: 20px
    color: $cloud-burst
    cursor: pointer
    margin: 20px 0
    max-width: 150px
    padding: 7px
    text-align: center

    &:hover
      background: rgba(255, 255, 255, 0.9)

  .no-more-add
    margin: 10px 10px
    color $storm-gray
    opacity 0.5
</style>